"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _F7D3HWZNcjs = require('./F7D3HWZN.cjs');


var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/composite/composite-separator.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "hr";
var useCompositeSeparator = _PTOCUU2Dcjs.createHook.call(void 0, function useCompositeSeparator2({ store, ...props }) {
  const context = _UCZW3OGHcjs.useCompositeContext.call(void 0, );
  store = store || context;
  _misc.invariant.call(void 0, 
    store,
    process.env.NODE_ENV !== "production" && "CompositeSeparator must be wrapped in a Composite component."
  );
  const orientation = _FH6HQ5JNcjs.useStoreState.call(void 0, 
    store,
    (state) => state.orientation === "horizontal" ? "vertical" : "horizontal"
  );
  props = _F7D3HWZNcjs.useSeparator.call(void 0, { ...props, orientation });
  return props;
});
var CompositeSeparator = _PTOCUU2Dcjs.forwardRef.call(void 0, function CompositeSeparator2(props) {
  const htmlProps = useCompositeSeparator(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useCompositeSeparator = useCompositeSeparator; exports.CompositeSeparator = CompositeSeparator;
